<template>
	<div class="ui-button">
		<div
			:class="disable ? 'ui-button__disable' : 'ui-button__element'"
			:style="disable ? styleDisable : style"
		>
			<div
				class="ui-button__element_label"
				:style="{ fontWeight, fontSize }"
			>
				<div v-if="!disable">{{ label }}</div>
				<EllipsisLoader v-if="disable" />
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import EllipsisLoader from "@/components/preloader/EllipsisLoader.vue";

@Options({
	components: { EllipsisLoader },
	props: {
		label: { type: String, default: "" },
		color: { type: String, default: "#313132" },
		backgroundColor: { type: String, default: "#FADC42" },
		borderColor: { type: String, default: "#DFE6EE" },
		fontWeight: { type: String, default: "400" },
		fontSize: { type: String, default: "14px" },
		disable: { type: Boolean, default: false },
	},
})
export default class UiButton extends Vue {
	backgroundColor: string;
	borderColor: string;
	color: string;

	public readonly styleDisable =
		"background-color: #d9d9d9; border-color: #DFE6EE";

	public get bgColor() {
		return this.backgroundColor;
	}

	public get brColor() {
		return this.borderColor;
	}

	public get style() {
		return (
			"background-color: " +
			this.bgColor +
			"; border: 1px solid " +
			this.brColor +
			"; color: " +
			this.color
		);
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.ui-button {
	user-select: none;

	&__element {
		padding: 14px 10px 14px 10px;
		border-radius: 12px;
		cursor: pointer;
	}

	&__disable {
		padding: 12px 16px 12px 16px;
		border-radius: 12px;
		cursor: not-allowed;
	}

	&__element_label {
		text-align: center;
	}
}
</style>
